import * as React from 'react';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import { Logging } from '../..';
import FooterProps from './FooterProps.interface';
import './footer.scss';

const Footer = ({
  onCancel = null,
  cancelLink = null,
  cancelText = 'Cancel',
  cancelVisible = true,
  cancelEnabled = true,
  onValidate = null,
  validateText = 'Validate',
  validateVisible = false,
  validateEnabled = false,
  onSave,
  saveText = 'Save',
  saveVisible = true,
  saveEnabled = true,
}: FooterProps): JSX.Element => {
  Logging.Debug('Footer');

  return (
    <>
      {/* Horizontal Line and Footer */}
      <hr />
      <div className="footerContainer">
        <div className="footerContainerLeft">
          {
            cancelVisible
            && (
              <>
                {
                  cancelLink
                    ? (
                      <div className="buttonItemBase">
                        <a href={cancelLink} title="Cancel">
                          <VtxButton
                            id="cancelButton"
                            icon={<VtxIcon type="stop" />}
                            disabled={!cancelEnabled}
                            type="default"
                          >
                            {cancelText}
                          </VtxButton>
                        </a>
                      </div>
                    )
                    : (
                      <div className="buttonItemBase">
                        <VtxButton
                          id="cancelButton"
                          icon={<VtxIcon type="stop" />}
                          disabled={!cancelEnabled}
                          onClick={onCancel}
                          type="default"
                        >
                          {cancelText}
                        </VtxButton>
                      </div>
                    )
                }
              </>
            )
          }
        </div>
        <div className="footerContainerRight">
          {
            validateVisible
            && (
              <div className="buttonItemBase">
                <VtxButton
                  id="validateButton"
                  disabled={!validateEnabled}
                  onClick={onValidate}
                  type="primary"
                >
                  {validateText}
                </VtxButton>
              </div>
            )
          }
          {
            saveVisible
            && (
              <div className="buttonItemBase">
                <VtxButton
                  id="saveButton"
                  disabled={!saveEnabled}
                  onClick={onSave}
                  type="primary"
                >
                  {saveText}
                </VtxButton>
              </div>
            )
          }
        </div>
      </div>
    </>
  );
};

export default Footer;
